import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { Badge } from "@vds/badges";
import { Button, TextLink, TextLinkCaret } from "@vds/buttons";
import { Modal, ModalBody, ModalTitle } from "@vds/modals";
import { Title, Body } from "@vds/typography";
import { setGWJointOfferSelected } from "pages/Mobility/ducks/MobilitySlice";
import { MarginSpacerL, MarginSpacerXS } from "../styleTag";
import {
  ProductBoxWrap,
  LaptopProductBoxWrap,
  TextOnImageWrapper,
  TextOnImage,
  SubtextOnImage,
  LinkTextOnImage,
  LinkButton,
  DeviceContainer,
  DetailsModal,
  DetailsModalBody,
} from "./styles";
import "./PromoCard.css";

const PromoCard = ({ aem, aemContent, promoType, ...props }) => {
  const [additionalURL, handleAdditionalURL] = useState("");
  const [showNseModal, setShowNseModal] = useState(false);
  const [showJoModal, setShowJoModal] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pageData = useSelector((state) => state.MobilityPage);
  const isMobile = useMediaQuery({
    query: "(max-width: 954px)",
  });
  const detailsModalAem = props?.detailsNseModalAem
    ? props?.detailsNseModalAem
    : props?.detailsJOModalAem;

  const zipCodeFromLearn = useSelector((state) => {
    return (
      state.PlanFirst?.addressFromLearn?.zipCode ??
      state.PlanFirst?.addressFromLearn?.zipCodeVal
    );
  });
  const movePDPAddressModaltoGW = true;

  const getImageUrl = (url) => {
    if (!(typeof url === "string" && url?.length)) {
      return "";
    } else if (url.charAt(0) === "/") {
      return `${window?.mbtGlobal?.assetsBaseUrl}${url}`;
    } else {
      return url;
    }
  };

  const getImageHeight = () => {
    if ("connectedLaptops" === promoType) {
      return "98%";
    }
    return null;
  };

  useEffect(() => {
    if (String(props.type).includes("non-smartPhone")) {
      const addURL = String(props.category)?.toLowerCase().split(" ");
      const resultURL =
        addURL.length > 1 ? addURL[0] + "-" + addURL[1] : addURL[0];
      handleAdditionalURL(resultURL + "/byod");
    }
  }, [props.category]);

  const popularDevice = props?.type === "popularDevice";

  return (
    <>
      <DeviceContainer
        className={`device-card-promo ${
          props?.isEnableVBC ? " vbc-plnCard" : ""
        }`}
      >
        {props.isEnableVBC &&
        aemContent.enableVBC === true &&
        props.eligibleVBC ? (
          String(props.type).includes("connectedLaptops") ||
          String(props.type).includes("laptops") ? (
            <>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  if (!pageData?.bundleOfferSelected)
                    dispatch(setGWJointOfferSelected(false));
                  let URL = aemContent?.externalUrl
                    ? aemContent?.url
                    : aemContent?.relativeUrl + additionalURL;
                  if (
                    String(props.type).includes("connectedLaptops") &&
                    window.location.pathname.includes("/mbt/prospect")
                  ) {
                    URL = aemContent?.lowerEnvUrl;
                  }
                  if (aemContent?.externalUrl) {
                    window.open(URL, "_blank");
                  } else {
                    navigate(`/${URL}`);
                  }
                }}
              >
                <LaptopProductBoxWrap
                  isMobile={isMobile}
                  imgHeight={getImageHeight()}
                  isEnableVBC={props?.isEnableVBC && aemContent?.enableVBC}
                  isEligibleVBC={props?.eligibleVBC}
                  url={getImageUrl(aemContent?.ss7ImgUrl)}
                >
                  <TextOnImageWrapper
                    isEnableVBC={props.isEnableVBC && aemContent?.enableVBC}
                    isEligibleVBC={props.eligibleVBC}
                  >
                    <Badge fillColor="red">
                      {props?.aemContent?.badgetext}
                    </Badge>
                    {!!aemContent?.headerText && (
                      <TextOnImage
                        size={
                          props.isEnableVBC && aemContent?.enableVBC
                            ? isMobile
                              ? "small"
                              : "large"
                            : "medium"
                        }
                        color="#ffffff"
                        bold
                      >
                        {aemContent?.headerText}
                      </TextOnImage>
                    )}
                    {!!aemContent?.subHeaderTextPromo && (
                      <SubtextOnImage size="medium" color="#ffffff">
                        {aemContent?.subHeaderTextPromo}
                      </SubtextOnImage>
                    )}
                    <div
                      className={props?.isEnableVBC ? "getButtomAtBottom" : ""}
                    >
                      {!!aemContent?.subHeaderText && (
                        <SubtextOnImage size="medium" color="#ffffff">
                          {aemContent?.subHeaderText}
                        </SubtextOnImage>
                      )}
                      {!!aemContent?.linkText && (
                        <LinkTextOnImage>
                          <LinkButton
                            data-track={`BYOD:${aemContent?.linkText}`}
                          >
                            {aemContent?.linkText}
                          </LinkButton>
                        </LinkTextOnImage>
                      )}
                    </div>
                  </TextOnImageWrapper>
                </LaptopProductBoxWrap>
              </a>
              <a
                onClick={(e) => {
                  props.isVBClicked();
                }}
              >
                <ProductBoxWrap
                  isMobile={isMobile}
                  imgHeight={getImageHeight()}
                  isEnableVBC={props?.isEnableVBC}
                  isEligibleVBC={props?.eligibleVBC}
                  url={getImageUrl(aemContent?.ss7ImgUrl)}
                >
                  <TextOnImageWrapper
                    isEnableVBC={props?.isEnableVBC}
                    isEligibleVBC={props?.eligibleVBC}
                  >
                    {!!props.aemcontentVBC?.headerText && (
                      <TextOnImage
                        size={
                          props.isEnableVBC && aemContent?.enableVBC
                            ? isMobile
                              ? "small"
                              : "large"
                            : "medium"
                        }
                        color="#ffffff"
                        bold
                      >
                        {props.aemcontentVBC?.headerText}
                      </TextOnImage>
                    )}
                    <div
                      className={props?.isEnableVBC ? "getButtomAtBottom" : ""}
                    >
                      {!!props.aemcontentVBC?.subHeaderText && (
                        <SubtextOnImage
                          size={
                            props.isEnableVBC &&
                            aemContent?.enableVBC &&
                            isMobile
                              ? "small"
                              : "medium"
                          }
                          color="#ffffff"
                        >
                          {props.aemcontentVBC?.subHeaderText}
                        </SubtextOnImage>
                      )}
                      {!!props.aemcontentVBC?.linkText && (
                        <LinkTextOnImage>
                          <LinkButton
                            data-track={`VBC:${props.aemcontentVBC?.linkText}`}
                          >
                            {props.aemcontentVBC?.linkText}
                          </LinkButton>
                        </LinkTextOnImage>
                      )}
                    </div>
                  </TextOnImageWrapper>
                </ProductBoxWrap>
              </a>
            </>
          ) : (
            <>
              <a
                className="VBC-promo-byod-link"
                onClick={(e) => {
                  e.preventDefault();
                  if (!pageData?.bundleOfferSelected)
                    dispatch(setGWJointOfferSelected(false));
                  let URL = aemContent?.externalUrl
                    ? aemContent?.url
                    : aemContent?.relativeUrl + additionalURL;
                  if (
                    String(props.type).includes("connectedLaptops") &&
                    window.location.pathname.includes("/mbt/prospect")
                  ) {
                    URL = aemContent?.lowerEnvUrl;
                  }
                  if (aemContent?.externalUrl) {
                    window.open(URL, "_blank");
                  } else {
                    if (!movePDPAddressModaltoGW) {
                      navigate(`/${URL}`);
                    } else if (
                      (!!pageData?.zipcodeFromGW ||
                        !!pageData?.zipCode ||
                        !!zipCodeFromLearn) &&
                      movePDPAddressModaltoGW
                    ) {
                      navigate(`/${URL}`);
                    } else {
                      props?.onChangeRefFromByodCard(true, URL);
                      props?.setForDeviceCard(true);
                      props?.setShowNewCustomerModal(true);
                    }
                  }
                }}
              >
                <ProductBoxWrap
                  isMobile={isMobile}
                  imgHeight={getImageHeight()}
                  isEnableVBC={props?.isEnableVBC && aemContent?.enableVBC}
                  isEligibleVBC={props?.eligibleVBC}
                  url={getImageUrl(aemContent?.ss7ImgUrl)}
                >
                  <TextOnImageWrapper
                    isEnableVBC={props?.isEnableVBC}
                    isEligibleVBC={props?.eligibleVBC}
                  >
                    {aemContent?.isoffer === true ? (
                      <Badge fillColor="red">{aemContent?.badgetext}</Badge>
                    ) : (
                      ""
                    )}
                    <MarginSpacerXS />
                    {!!aemContent?.headerText && (
                      <TextOnImage
                        size={
                          props.isEnableVBC && aemContent?.enableVBC
                            ? isMobile
                              ? "medium"
                              : "large"
                            : "medium"
                        }
                        color="#ffffff"
                        bold
                      >
                        {aemContent?.headerText}
                      </TextOnImage>
                    )}
                    <div
                      className={props?.isEnableVBC ? "getButtomAtBottom" : ""}
                    >
                      {!!aemContent?.subHeaderText && (
                        <SubtextOnImage
                          size={
                            props.isEnableVBC &&
                            aemContent?.enableVBC &&
                            isMobile
                              ? "small"
                              : "medium"
                          }
                          color="#ffffff"
                        >
                          {aemContent?.subHeaderText}
                        </SubtextOnImage>
                      )}
                      {!!aemContent?.linkText && (
                        <LinkTextOnImage>
                          <LinkButton
                            data-track={`BYOD:${aemContent?.linkText}`}
                          >
                            {aemContent?.linkText}
                          </LinkButton>
                        </LinkTextOnImage>
                      )}
                    </div>
                  </TextOnImageWrapper>
                </ProductBoxWrap>
              </a>
              <a
                className="VBC-promo-smartphone-link"
                onClick={(e) => {
                  props.isVBClicked();
                }}
              >
                <ProductBoxWrap
                  isMobile={isMobile}
                  imgHeight={getImageHeight()}
                  isEnableVBC={props?.isEnableVBC}
                  isEligibleVBC={props?.eligibleVBC}
                  url={getImageUrl(aemContent?.ss7ImgUrl)}
                >
                  <TextOnImageWrapper
                    isEnableVBC={props?.isEnableVBC}
                    isEligibleVBC={props?.eligibleVBC}
                  >
                    {!!props.aemcontentVBC?.headerText && (
                      <TextOnImage
                        size={
                          props.isEnableVBC && aemContent?.enableVBC
                            ? isMobile
                              ? "medium"
                              : "large"
                            : "medium"
                        }
                        color="#ffffff"
                        bold
                      >
                        {props.aemcontentVBC?.headerText}
                      </TextOnImage>
                    )}
                    <div
                      className={props?.isEnableVBC ? "getButtomAtBottom" : ""}
                    >
                      {!!props.aemcontentVBC?.subHeaderText && (
                        <SubtextOnImage
                          size={
                            props.isEnableVBC &&
                            aemContent?.enableVBC &&
                            isMobile
                              ? "small"
                              : "medium"
                          }
                          color="#ffffff"
                        >
                          {props.aemcontentVBC?.subHeaderText}
                        </SubtextOnImage>
                      )}
                      {!!props.aemcontentVBC?.linkText && (
                        <LinkTextOnImage>
                          <LinkButton
                            data-track={`VBC:${props.aemcontentVBC?.linkText}`}
                          >
                            {props.aemcontentVBC?.linkText}
                          </LinkButton>
                        </LinkTextOnImage>
                      )}
                    </div>
                  </TextOnImageWrapper>
                </ProductBoxWrap>
              </a>
            </>
          )
        ) : (
          <a
            onClick={(e) => {
              e.preventDefault();
              dispatch(setGWJointOfferSelected(false));
              let URL = aemContent?.externalUrl
                ? aemContent?.url
                : aemContent?.relativeUrl + additionalURL;
              if (
                String(props.type).includes("connectedLaptops") &&
                window.location.pathname.includes("/mbt/prospect")
              ) {
                URL = aemContent?.lowerEnvUrl;
              }
              if (props?.isQuickCartDevice) {
                props.isDeviceClicked();
              } else if (aemContent?.externalUrl) {
                window.open(URL, "_blank");
              } else {
                if (!movePDPAddressModaltoGW) {
                  navigate(`/${URL}`);
                } else if (
                  (pageData?.zipcodeFromGW ||
                    pageData?.zipCode ||
                    !!zipCodeFromLearn) &&
                  movePDPAddressModaltoGW
                ) {
                  navigate(`/${URL}`);
                } else {
                  props?.onChangeRefFromByodCard(true, URL);
                  props?.setForDeviceCard(true);
                  props?.setShowNewCustomerModal(true);
                }
              }
            }}
          >
            {String(props.type).includes("connectedLaptops") ||
            String(props.type).includes("laptops") ? (
              <LaptopProductBoxWrap
                isMobile={isMobile}
                imgHeight={getImageHeight()}
                url={
                  aemContent.ss7ImgUrl ? getImageUrl(aemContent?.ss7ImgUrl) : ""
                }
                isEnableVBC={props?.isEnableVBC && aemContent?.enableVBC}
                isEligibleVBC={props.isEligibleVBC}
              >
                <TextOnImageWrapper
                  isEnableVBC={props?.isEnableVBC && aemContent?.enableVBC}
                  isEligibleVBC={props?.eligibleVBC}
                >
                  {!!aemContent?.headerText && (
                    <TextOnImage size="medium" color="#ffffff" bold>
                      {aemContent?.headerText}
                    </TextOnImage>
                  )}
                  {!!aemContent?.subHeaderTextPromo && (
                    <SubtextOnImage size="medium" color="#ffffff">
                      {aemContent?.subHeaderTextPromo}
                    </SubtextOnImage>
                  )}
                  {!!aemContent?.subHeaderText && (
                    <SubtextOnImage
                      size={
                        props.isEnableVBC && aemContent?.enableVBC && isMobile
                          ? "small"
                          : "medium"
                      }
                      color="#ffffff"
                    >
                      {aemContent?.subHeaderText}
                    </SubtextOnImage>
                  )}
                  {!!aemContent?.linkText && (
                    <LinkTextOnImage>
                      {aemContent?.linkText}
                      <TextLinkCaret
                        surface="dark"
                        iconPosition="right"
                      ></TextLinkCaret>
                    </LinkTextOnImage>
                  )}
                </TextOnImageWrapper>
              </LaptopProductBoxWrap>
            ) : (
              <ProductBoxWrap
                isMobile={isMobile}
                imgHeight={getImageHeight()}
                isEnableVBC={props?.isEnableVBC && aemContent?.enableVBC}
                isEligibleVBC={props?.eligibleVBC}
                url={
                  aemContent.ss7ImgUrl ? getImageUrl(aemContent?.ss7ImgUrl) : ""
                }
              >
                {props?.fromBuyNowFlow && aemContent?.displayImage ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      paddingTop: "2rem",
                    }}
                  >
                    <div
                      style={{
                        backgroundImage: `url(${aemContent?.displayImage})`,
                        width: aemContent?.width,
                        height: aemContent?.height,
                      }}
                    ></div>
                  </div>
                ) : (
                  <></>
                )}
                <TextOnImageWrapper
                  isEnableVBC={props?.isEnableVBC && aemContent?.enableVBC}
                  isEligibleVBC={props?.eligibleVBC}
                  enableVBCStyle={aemContent?.enableVBCStyle}
                  popularDevice={popularDevice}
                >
                  {aemContent?.isoffer === true ? (
                    <Badge fillColor="red">{aemContent?.badgetext}</Badge>
                  ) : (
                    ""
                  )}
                  {!!aemContent?.headerText && (
                    <TextOnImage color="#ffffff" bold size="small">
                      {(props?.isEnableVBC && aemContent?.enableVBC) ||
                      aemContent?.enableVBCStyle ? (
                        <div
                          style={{ fontSize: "2.5rem", lineHeight: "2.5rem" }}
                        >
                          {aemContent?.headerText}
                        </div>
                      ) : (
                        aemContent?.headerText
                      )}
                    </TextOnImage>
                  )}
                  <div
                    className={props?.isEnableVBC ? "getButtomAtBottom" : ""}
                  >
                    {!!aemContent?.subHeaderText && (
                      <SubtextOnImage
                        size={
                          props.isEnableVBC && aemContent?.enableVBC && isMobile
                            ? "small"
                            : "medium"
                        }
                        color="#ffffff"
                      >
                        {aemContent?.subHeaderText}
                        {props?.isQuickCartDevice && (
                          <TextLink
                            size="small"
                            color="#ffffff"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (props?.detailsClick) {
                                setShowNseModal(true);
                              } else {
                                setShowJoModal(true);
                              }
                            }}
                          >
                            <span>{aemContent?.subHeaderTextLink}</span>
                          </TextLink>
                        )}
                      </SubtextOnImage>
                    )}
                    {popularDevice ? <MarginSpacerL /> : <></>}
                    {!!aemContent?.linkText && (
                      <LinkTextOnImage>
                        {props?.isEnableVBC &&
                        !window.location.pathname.includes("tablets") ? (
                          <LinkButton>{aemContent?.linkText}</LinkButton>
                        ) : (
                          <>
                            {" "}
                            {aemContent?.linkText}
                            <TextLinkCaret
                              surface="dark"
                              iconPosition="right"
                            ></TextLinkCaret>
                          </>
                        )}
                      </LinkTextOnImage>
                    )}
                  </div>
                </TextOnImageWrapper>
              </ProductBoxWrap>
            )}
          </a>
        )}
        {showNseModal ? (
          <DetailsModal
            opened={showNseModal}
            onOpenedChange={(val) => {
              setShowNseModal(val);
              if (
                props?.onDetailsClick &&
                typeof props?.onDetailsClick == "function"
              )
                props?.onDetailsClick(val);
            }}
            className="card-modal"
          >
            <>
              <ModalTitle>{detailsModalAem?.title}</ModalTitle>
              <DetailsModalBody className="card-modal-body">
                {detailsModalAem?.contentPara1 && (
                  <Body>{detailsModalAem?.contentPara1}</Body>
                )}
                {detailsModalAem?.contentPara2 && (
                  <Body>{detailsModalAem?.contentPara2}</Body>
                )}
              </DetailsModalBody>
            </>
          </DetailsModal>
        ) : (
          <DetailsModal
            opened={showJoModal}
            onOpenedChange={(val) => {
              setShowJoModal(val);
              if (
                props?.onDetailsClick &&
                typeof props?.onDetailsClick == "function"
              )
                props?.onDetailsClick(val);
            }}
            className="card-modal"
          >
            <>
              <ModalTitle>{detailsModalAem?.title}</ModalTitle>
              <DetailsModalBody className="card-modal-body">
                {detailsModalAem?.contentPara1 && (
                  <Body>{detailsModalAem?.contentPara1}</Body>
                )}
                {detailsModalAem?.contentPara2 && (
                  <Body>{detailsModalAem?.contentPara2}</Body>
                )}
              </DetailsModalBody>
            </>
          </DetailsModal>
        )}
      </DeviceContainer>
    </>
  );
};

export default PromoCard;
